import CollectionSolutionView from './CollectionSolutionView'

export default CollectionSolutionView
